import script from "./TodoDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TodoDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./TodoDetailModal.vue?vue&type=style&index=0&id=39d20a1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39d20a1e"]])

export default __exports__